import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions =
  reactQueryFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions,
    (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        dimension,
        reportDt,
        nActionsAsBestActions,
      }: GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsParams
    ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsResult> => {
      return fetch(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/insights/personalization_explainer/${dimension}/actions`,
        "GET",
        { report_dt: reportDt, n_actions_as_best_actions: nActionsAsBestActions },
        { signal },
        { propagateFetchRequestError: false }
      );
    },
    isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsResult
  );
